import React from "react";
import { useTranslation } from "react-i18next";

interface PagerControlsProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

/** Previous / Next pager used under the billing grids. Renders nothing for a single page. */
const PagerControls: React.FC<PagerControlsProps> = ({ page, totalPages, onPageChange }) => {
  const { t } = useTranslation();
  if (totalPages <= 1) return null;

  return (
    <div className="flex items-center justify-center gap-4">
      <button type="button" className="btn btn-secondary" disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}>
        {t("billing.common.previous")}
      </button>
      <span className="text-sm text-grey-30 dark:text-grey-70">
        {t("billing.common.pageOf", { page, totalPages })}
      </span>
      <button type="button" className="btn btn-secondary" disabled={page >= totalPages}
        onClick={() => onPageChange(page + 1)}>
        {t("billing.common.next")}
      </button>
    </div>
  );
};

export default PagerControls;
